// eslint-disable-next-line import/prefer-default-export
export const toggleGoogleTranslate = doToggle => ({
  type: 'GOOGLE_TRANSLATE/TOGGLE',
  doToggle,
});
